export const defaultSidebarMenuConfig = [
    {
        label: "Management",
        items: [
            {
                menuKey: "student-records",
                menuTitle: "Student Records",
                menuIcon: "lucide:users",
                navigationPath: "/student-records",
            },
            {
                menuKey: "division-configuration",
                menuTitle: "Division Configuration",
                menuIcon: "material-symbols:account-tree-outline",
                navigationPath: "/division-configuration",
            },
            {
                menuKey: "division-assignment",
                menuTitle: "Division Assignment",
                menuIcon: "material-symbols:assignment-ind-outline",
                navigationPath: "/division-assignment",
            },
            {
                menuKey: "government-announcement",
                menuTitle: "Government Announcement",
                menuIcon: "material-symbols:assignment-ind-outline",
                navigationPath: "/government-announcement",
            },
            {
                menuKey: "student-notification-management",
                menuTitle: "Student Notifications",
                menuIcon: "solar:bell-bing-bold-duotone",
                navigationPath: "/student-notification-management",
            },
            {
                menuKey: "education-dashboard-analytics",
                menuTitle: "Education Dashboard Analytics",
                menuIcon: "solar:chart-2-bold-duotone",
                navigationPath: "/education-dashboard-analytics",
            },
            {
                menuKey: "student-promotion-detention",
                menuTitle: "Student Promotion / Detention Flow",
                menuIcon: "material-symbols:trending-up",
                navigationPath: "/promotion-detention",
            },
            {
                menuKey: "detained-students",
                menuTitle: "Detained Students",
                menuIcon: "material-symbols:person-off-outline",
                navigationPath: "/detained-students",
            },
        ],
    },
];
